document.addEventListener('DOMContentLoaded', () => {

  function parsePrice(text) {
    if (!text) return NaN;
    let s = text.replace(/[^\d.,]/g, '');
    if (s.indexOf('.') > -1 && s.indexOf(',') > -1) {
      if (s.indexOf('.') < s.indexOf(',')) {
        s = s.replace(/\./g, '').replace(',', '.');
      } else {
        s = s.replace(/,/g, '');
      }
    } else {
      s = s.replace(/,/g, '.');
    }
    return parseFloat(s);
  }

  function formatPrice(v, currency = '') {
    return v.toFixed(3) + (currency ? ' ' + currency : '');
  }

  function apply(card) {
    if (card.dataset.discountApplied === 'true') return true;

    const badges = card.querySelectorAll('.pl-text');

    let percent = null;
    let flat = null;

    for (const el of badges) {
      const text = el.innerText.toLowerCase();

      const percentMatch = text.match(/(\d+(?:\.\d+)?)\s*%/);
      if (percentMatch) {
        percent = parseFloat(percentMatch[1]);
        break;
      }

      const flatMatch = text.match(/(\d+(?:\.\d+)?)\s*(kwd|kd)/i);
      if (flatMatch) {
        flat = parseFloat(flatMatch[1]);
        break;
      }
    }

    if (percent === null && flat === null) return false;

    let regEl = card.querySelector('.price-item--regular.gg')
              || card.querySelector('.price-item--regular')
              || card.querySelector('.price__regular .price-item--regular');

    if (!regEl) return false;

    const raw = regEl.innerText;
    const price = parsePrice(raw);
    if (isNaN(price)) return false;

    const currency = ((raw.match(/[A-Za-z]{1,4}$/) || [])[0] || '').trim();
    let discounted;

    if (percent !== null) {
      discounted = price * (100 - percent) / 100;
    }

    if (flat !== null) {
      discounted = price - flat;
    }

    discounted = Math.max(discounted, 0);

    const container = regEl.closest('.price__container') || regEl.parentElement || regEl;

    const html =
      `<span class="price-item price-item--sale price-item--last">${formatPrice(discounted, currency)}</span>
      <span class="price-item price-item--regular jh"><s>${formatPrice(price, currency)}</s></span>`;

    container.innerHTML = html;

    card.dataset.discountApplied = 'true';
    return true;
  }

  document.querySelectorAll('.product-card-wrapper').forEach(card => {
    if (apply(card)) return;

    const obs = new MutationObserver(() => {
      if (apply(card)) obs.disconnect();
    });

    obs.observe(card, { childList: true, subtree: true });
    setTimeout(() => { try { obs.disconnect(); } catch(e){} }, 15000);
  });

});
